import { jsx } from 'react/jsx-runtime';

/** ![minimizeIcon](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiI+PHJlY3QgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjZmZmIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiLz48cGF0aCBkPSJNOCAzdjNhMiAyIDAgMCAxLTIgMkgzTTIxIDhoLTNhMiAyIDAgMCAxLTItMlYzTTMgMTZoM2EyIDIgMCAwIDEgMiAydjNNMTYgMjF2LTNhMiAyIDAgMCAxIDItMmgzIi8+PC9zdmc+) */
const minimizeIcon = /*#__PURE__*/jsx("path", {
  d: "M8 3v3a2 2 0 0 1-2 2H3M21 8h-3a2 2 0 0 1-2-2V3M3 16h3a2 2 0 0 1 2 2v3M16 21v-3a2 2 0 0 1 2-2h3"
});

export { minimizeIcon };
